import { memo, Ref } from "react";

import TableBodyRow from "ds/components/Table/Row";
import { TableColumnMeta } from "ds/components/Table/types";
import { isStickyLeft, isStickyRight } from "ds/components/TableSimple/helpers";
import { StackPullRequestItem } from "shared/Stack/useStackPullRequests/gql";
import { VcsProvider } from "types/generated";

import { STACK_PULL_REQUESTS_PULL_REQUEST_CELLS } from "../Cells/PullRequest";

type StackPullRequestsTableRowPullRequestProps = {
  pullRequest: StackPullRequestItem;
  stackId: string;
  stackProvider: VcsProvider;
  isAnsible: boolean;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: Ref<HTMLDivElement>;
  dataIndex: number;
  isGroupOpen?: boolean;
  isExpanded?: boolean;
  className?: string;
};

const StackPullRequestsTableRowPullRequest = ({
  pullRequest,
  stackId,
  stackProvider,
  isAnsible,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
  isGroupOpen,
  className,
  isExpanded,
}: StackPullRequestsTableRowPullRequestProps) => (
  <TableBodyRow
    {...keyboardProps}
    ref={measureRef}
    dataIndex={dataIndex}
    virtualized
    className={className}
    isGroupOpen={isGroupOpen}
    aria-level={1}
    aria-expanded={isExpanded}
  >
    {columns.map((column, i) => {
      const Cell = STACK_PULL_REQUESTS_PULL_REQUEST_CELLS[column.id];
      const cellId = `${pullRequest.id}-${column.id}`;

      return (
        <Cell
          key={cellId}
          id={cellId}
          item={pullRequest}
          isFirst={i === 0}
          stickyLeft={isStickyLeft(i, isFirstColumnPinned)}
          stickyRight={isStickyRight(i, columns.length)}
          stackId={stackId}
          stackProvider={stackProvider}
          isAnsible={isAnsible}
        />
      );
    })}
  </TableBodyRow>
);

export default memo(StackPullRequestsTableRowPullRequest);
